export default "__VITE_ASSET__v9pkwTpx__"